<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="1"
          :cloumnId="cloumnId"
          v-if="!isMobile"
        >
          <div slot="main_content">
            <div class="content_top" v-if="listTab.length">
              <div class="content_con">
                <div class="content_l">
                  <div
                    :class="['list_tab', currentTab == index ? 'active' : '']"
                    v-for="(l, index) in listTab"
                    :key="index"
                    @click="handleTab(l, index)"
                  >
                    <div class="list_tab_t">
                      <span>{{ l.time }}</span>
                      <img src="../../assets/img/notice_arrow.png" />
                    </div>
                    <div class="list_tab_d">{{ l.title }}</div>
                    <div class="line"></div>
                  </div>
                  <div class="content_l_d">
                    <div class="preArtical" @click="handlePage(0)">
                      {{ $t('prevPage') }}
                    </div>
                    <div class="nextArtical" @click="handlePage(1)">
                      {{ $t('nextPage') }}
                    </div>
                  </div>
                </div>
                <div class="content_r">
                  <div class="content_detail">
                    <h3>{{ detail.title }}</h3>
                    <div class="detail_con" v-html="detail.content"></div>
                    <div class="thank_list" v-if="detail.specialThanks">
                      <div class="thank_title">{{ $t('specialthanks') }}</div>
                      <div
                        class="thank_item_con detail_con"
                        v-html="detail.specialThanks"
                      ></div>
                      <!-- <div
                          class="thank_item"
                          v-for="(t, index) in thankList"
                          :key="index"
                        >
                          <span v-if="index > 0">{{ index }}</span>
                          {{ t.name }}
                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="1"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="app_content_l">
                <div
                  :class="['list_tab', currentTab == index ? 'active' : '']"
                  v-for="(l, index) in listTab"
                  :key="index"
                  @click="toDetail(l.id, index)"
                >
                  <div class="list_tab_t">
                    <span>{{ l.time }}</span>
                    <img src="../../assets/img/notice_arrow.png" />
                  </div>
                  <div class="list_tab_d">{{ l.title }}</div>
                  <div class="line"></div>
                </div>
              </div>
            </div></div
        ></AppcontentList>
        <paginations
          v-if="isMobile"
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { newsTab } from '@/const';
import { fetchConentList, getObj } from '@/assets/api';
export default {
  name: 'Notice',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      page: { current: 1, size: 10, total: 20 },
      tabList: newsTab,

      cloumnId: null,
      currentTab: 0,
      listTab: [
        {
          title: '乌镇戏剧节 小镇图书馆 图书捐赠特别鸣谢',
          time: '2023-23-09',
          id: 1,
        },
        {
          title: '2022乌镇戏剧节青年竞演单元入围公告',
          time: '2023-23-09',
          id: 2,
        },
        {
          title: '乌镇戏剧节 小镇图书馆 图书捐赠特别鸣谢',
          time: '2023-23-09',
          id: 2,
        },
        {
          title: '2022乌镇戏剧节青年竞演单元入围公告',
          time: '2023-23-09',
          id: 2,
        },
        {
          title: '乌镇戏剧节 小镇图书馆 图书捐赠特别鸣谢',
          time: '2023-23-09',
          id: 2,
        },
        {
          title: '2022乌镇戏剧节青年竞演单元入围公告',
          time: '2023-23-09',
          id: 2,
        },
      ],
      detail: {
        title: '乌镇戏剧节 小镇图书馆 图书捐赠特别鸣谢',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;; background-color: rgb(255, 255, 255);">　　从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><div><br></div>',
      },
      thankList: [
        { name: '北京十月文艺出版社' },
        { name: '《曹禺全集（1）》' },
        { name: '《曹禺全集（2）》' },
        { name: '《曹禺全集（3）》' },
        { name: '《曹禺全集（4）》' },
      ],
      id: null,
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.getList();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      this.getList();
    },
    currentChange(e) {
      this.current = e;
      this.getList();
    },
    handlePage(sort) {
      if (sort == 0) {
        if (this.page.current * 10 < this.page.total) {
          this.current--;
          this.getList();
        } else {
          this.$message.warning(this.$t('isFirstPage'));
        }
      } else {
        if (this.page.current * 10 < this.page.total) {
          this.current++;
          this.getList();
        } else {
          this.$message.warning(this.$t('isLastPage'));
        }
      }
    },
    getList() {
      const data = {
        columnIds: this.cloumnId,
        size: this.page.size,
        current: this.page.current,
      };
      fetchConentList(data).then((res) => {
        this.listTab = res.records;
        this.page.total = res.total;

        if (this.id) {
          this.listTab.map((l, index) => {
            if (this.id == l.id) {
              this.currentTab = index;
            }
          });
          this.getDetail(this.id);
        } else {
          if (this.listTab.length) {
            this.getDetail(this.listTab[0].id);
          }
        }
      });
    },
    getDetail(id) {
      getObj(id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
    handleTab(v, index) {
      this.currentTab = index;
      this.getDetail(v.id);
    },
    toDetail(id) {
      this.$router.push({
        path: `/newsDetail?id=${id}&cloumnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 40px 0;

    .content_con {
      display: flex;
      justify-content: space-between;
      .content_l {
        width: 31%;
        box-sizing: border-box;
        background: #fff;
        .list_tab {
          padding: 0.75rem 1.5rem 0;

          .list_tab_t {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              color: #6b6d7a;
              font-size: 0.875rem;
            }
            img {
              width: 1.25rem;
              height: 1.25rem;
            }
          }
          .list_tab_d {
            text-align: left;
            color: #424451;
            font-size: 1.125rem;
            line-height: 1.5rem;
            margin-top: 0.625rem;
          }
        }
        .line {
          width: 100%;
          margin: 0.75rem 0 0;
          height: 0.0625rem;
          background: linear-gradient(
            180deg,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          );
        }
        .active {
          background: linear-gradient(
            to right,
            rgba(173, 208, 247, 0) 0%,
            rgba(170, 229, 239, 0.5) 50%,
            rgba(177, 187, 255, 0) 100%
          );
        }
        .content_l_d {
          margin: 1.5rem;
          display: flex;
          justify-content: space-between;
          color: #6b6d7a;
          .preArtical {
            width: 45%;
            text-align: left;
            font-size: 1.25rem;
            padding-bottom: 0.3333rem;
            border-bottom: 0.1667rem solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
            cursor: pointer;
            &::before {
              content: '';
              display: inline-block;
              width: 0.6667rem;
              height: 0.6667rem;
              border-left: 0.0833rem solid #6b6d7a;
              border-top: 0.0833rem solid #6b6d7a;
              transform: rotate(-45deg);
            }
          }
          .nextArtical {
            width: 45%;
            text-align: right;
            font-size: 1.25rem;
            padding-bottom: 0.3333rem;
            border-bottom: 0.1667rem solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
            cursor: pointer;
            &::after {
              content: '';
              display: inline-block;
              width: 0.6667rem;
              height: 0.6667rem;
              border-right: 0.0833rem solid #6b6d7a;
              border-top: 0.0833rem solid #6b6d7a;
              transform: rotate(45deg);
            }
          }
        }
      }
      .content_r {
        flex: 1;
        margin-left: 2rem;
        background: #fff;
        .content_detail {
          padding: 1.875rem;
          h3 {
            font-size: 2.25rem;
            color: #424451;
            padding-bottom: 0.3333rem;
            border-bottom: 0.1667rem solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
            margin-bottom: 3.75rem;
            text-align: center;
          }
          .detail_con {
            color: #666;
            font-size: 1.125rem;
          }
          .thank_list {
            margin-top: 2rem;
            .thank_title {
              height: 3.75rem;
              line-height: 3.75rem;
              padding-left: 1.5rem;
              box-sizing: border-box;
              width: 100%;
              background: linear-gradient(to right, #aae5ef 0%, #b1bbff 100%);
              font-size: 1.5rem;
              color: #424451;
            }
            .thank_item_con {
              margin-top: 2rem;
              .thank_item {
                margin: 0.625rem;
                color: #666;
              }
            }
          }
        }
      }
    }
  }
  .app_content_top {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    margin: 2rem 0;
    min-height: 42.9vh;
    .app_content_l {
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      .list_tab {
        padding: 0.75rem 0 0;

        .list_tab_t {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 1rem;
          span {
            color: #6b6d7a;
            font-size: 1rem;
          }
          img {
            width: 1.3333rem;
            height: 1.3333rem;
          }
        }
        .list_tab_d {
          padding: 0 1rem;
          text-align: left;
          color: #424451;
          font-size: 1.125rem;
          line-height: 1.5rem;
          margin-top: 0.625rem;
        }
      }
      .line {
        width: 100%;
        margin: 0.75rem 0 0;
        height: 0;
        border-bottom: 0.0833rem solid;
        border-image: linear-gradient(
            90deg,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          )
          6 6;
      }
      .active {
        background: linear-gradient(
          to right,
          rgba(173, 208, 247, 0) 0%,
          rgba(170, 229, 239, 0.5) 50%,
          rgba(177, 187, 255, 0) 100%
        );
      }
    }
  }
}
::v-deep .detail_con {
  p,
  span {
    color: #666 !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
  }
}
</style>
